import styled from "styled-components";
import { useState, useEffect } from "react";
import FormStringInput from "../../../../../../components/FormControls/FormStringInput";
import FormCheckBox from "../../../../../../components/FormControls/FormCheckBox";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../../components/FormControls/SecondaryButton";
import WarningButton from "../../../../../../components/FormControls/WarningButton";
import request from "../../../../../../api/request";
import FormCheckBoxWithRightLabel from "../../../../../../components/FormControls/FormCheckBoxWithRightLabel";
import { NotificationManager } from 'react-notifications';

const StyledMainUserSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 708px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

const Note = styled.span`
    font-size: 9px;
    color: ${(props) => props.theme.color.gray};
    font-weight: 600;
`;

const WarningLabel = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: #DB0640;
    margin-left: 15px;
`;

function MainUserSettings(props) {

    const {users, selectedUser, isAddUserMode, setIsAddUserMode, refreshUsersCallback} = props;

    const [isSaving, setIsSaving] = useState(false);
    const [isSavingPassword, setIsSavingPassword] = useState(false);
    const [isUnlockingUser, setIsUnlockingUser] = useState(false);
    const [isUserLocked, setIsUserLocked] = useState(false);
    const [isUserReset, setIsUserReset] = useState(false);
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [receiveAllSupportEmails, setReceiveAllSupportEmails] = useState(false);
    const [supportEmail, setSupportEmail] = useState('');
    const [isCentralOffice, setIsCentralOffice] = useState(false);
    const [canAccessAllRecords, setCanAccessAllRecords] = useState(false);
    const [isTFA, setIsTFA] = useState(false);
    const [password, setPassword] = useState('');
    
    const [needsValidation, setNeedsValidation] = useState(false);

    const onSendEmail = async () => {
        if (email === '' && supportEmail === '') {
            setNeedsValidation(true);
        } else {
            setIsSendingEmail(true);
            let emailData = {};
            emailData.UserName = userName;
            emailData.Password = password;
            emailData.emailTo = supportEmail.length === 0 ? email : supportEmail;
            emailData.subject = 'CAMRA Admin password';
            emailData.text = `Dear ${userName},

This email was sent by CAMRA Accounting with your new login details.

UserName: ${userName}
Password: ${password} 

Thank you.`;

            const resp = (await request('database', 'sendEmail', [emailData]));
            if (resp.ok) {
                NotificationManager.success('Email sent');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsSendingEmail(false);
        }
    }
    
    const onSavePassword = async () => {
        if (password === '') {
            setNeedsValidation(true);
        } else 
        {
            setIsSavingPassword(true);
            let saveData = {};
            saveData.UserName = userName;
            saveData.Password = password;
            saveData.PasswordChangedOnDate = new Date();

            const resp = (await request('database', 'updateUser', [saveData]));
            if (resp.ok) {
                NotificationManager.success('Password is updated');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsSavingPassword(false);
            setIsAddUserMode(false);
        }
    };
    
    const onUnlockUser = async () => {
        setIsUnlockingUser(true);
        let data = {};
        data.UserName = userName;

        const resp = (await request('database', 'unlockUser', [data]));
        if (resp.ok) {
            NotificationManager.success('User is unlocked');
            setIsUserLocked(false);
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsUnlockingUser(false);
    };
    
    const onResetUser = async () => {
        setIsUnlockingUser(true);
        let data = {};
        data.UserName = userName;

        const resp = (await request('database', 'resetUser', [data]));
        if (resp.ok) {
            NotificationManager.success('User is reset');
            setIsUserReset(true);
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
    };
    
    const checkUserLocked = async (userName) => {
        let data = {};
        data.UserName = userName;

        const resp = (await request('database', 'checkUserLocked', [data]));
        if (resp.ok) {
            setIsUserLocked(resp.data);
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
    }

    const checkUserReset = async (userName) => {
        let data = {};
        data.UserName = userName;

        const resp = (await request('database', 'checkUserReset', [data]));
        if (resp.ok) {
            setIsUserReset(resp.data);
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
    }
    
    const onSaveChanges = async () => {
        if (userName === '' || email === '' || (password === '' && isAddUserMode)) {
            setNeedsValidation(true);
        } else 
        {
            setIsSaving(true);
            let saveData = {};
            saveData.UserName = userName;
            saveData.Email = email;
            saveData.ReceiveAllSupportEmails = receiveAllSupportEmails;
            saveData.SupportEmail = supportEmail.length ? supportEmail : null;
            saveData.IsCentralOffice = isCentralOffice;
            saveData.CanAccessAllRecords = canAccessAllRecords;
            saveData.EmailVerificationCode = null;
            saveData.IsTFA = isTFA;
            if (isAddUserMode) {
                saveData.Password = password;
                saveData.PasswordChangedOnDate = new Date();
            }

            const resp = (await request('database', isAddUserMode ? 'createUser' : 'updateUser', [saveData]));
            if (resp.ok && refreshUsersCallback) {
                refreshUsersCallback(userName);
                NotificationManager.success(isAddUserMode ? 'Created' : 'Updated' + ' user');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsSaving(false);
            setIsAddUserMode(false);
        }
    };

    const generateAlphabeticPassword = (len) => {
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let alphabeticPassword = '';
        for (let i = 0; i < len; i ++) {
            alphabeticPassword += letters[Math.floor(Math.random() * letters.length)]
        }
        return alphabeticPassword;
    }

    const generateNumericPassword = (len) => {
        const numbers = '0123456789';
        let numericPassword = '';
        for (let i = 0; i < len; i ++) {
            numericPassword += numbers[Math.floor(Math.random() * numbers.length)]
        }
        return numericPassword;
    }

    const generateRandomPassword = (len) => {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";// + "!@#$%^&*()_+=";
        let randomPassword = '';
        for (let i = 0; i < len; i ++) {
            randomPassword += characters[Math.floor(Math.random() * characters.length)]
        }
        return randomPassword;
    }

    const mixPassword = (password) => {
        let a = password.split(""),
        n = a.length;

        for(let i = n - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            let tmp = a[i];
            a[i] = a[j];
            a[j] = tmp;
        }
        return a.join("");
    }
    
    const onGeneratePassword = () => {
        let password = ''

        password += generateAlphabeticPassword(2);
        password += generateNumericPassword(2);
        password += generateRandomPassword(2);
        password = mixPassword(password);
        
        setPassword(password);
    };

    useEffect(() => {
        if (!isAddUserMode && selectedUser) {
            checkUserLocked(selectedUser.UserName);
            checkUserReset(selectedUser.UserName);

            setNeedsValidation(false);
            setUserName(selectedUser.UserName ? selectedUser.UserName : '');
            setEmail(selectedUser.Email ? selectedUser.Email : '');
            setReceiveAllSupportEmails(selectedUser.ReceiveAllSupportEmails ? selectedUser.ReceiveAllSupportEmails : false);
            setSupportEmail(selectedUser.SupportEmail ? selectedUser.SupportEmail : '');
            setIsCentralOffice(selectedUser.IsCentralOffice ? selectedUser.IsCentralOffice : false);
            setCanAccessAllRecords(selectedUser.CanAccessAllRecords ? selectedUser.CanAccessAllRecords : false);
            setIsTFA(selectedUser.IsTFA ? selectedUser.IsTFA : false);
            setPassword('');
        }
        if (isAddUserMode) {
            setNeedsValidation(false);
            setUserName('');
            setEmail('');
            setReceiveAllSupportEmails(false);
            setSupportEmail('');
            setIsCentralOffice(false);
            setCanAccessAllRecords(false);
            setIsTFA(false);
            setPassword('');
        }
    }, [selectedUser, isAddUserMode, users]);

    return (
        <StyledMainUserSettings>
            <WhiteBoard>
                <Title>User main details</Title>
                <div style={{display:'flex'}}>
                    <FormStringInput label='Username' value={userName} validated={needsValidation && userName === '' ? false : undefined} disabled={!isAddUserMode} onChange={(val) => setUserName(val)} inputStyle={{width:280}}></FormStringInput>
                    {isUserLocked && <div style={{paddingTop: 15}}>
                        <WarningLabel>Maximum login attempts reached.</WarningLabel>
                        <WarningButton caption='Unlock user' isLoading={isUnlockingUser} onClick={() => onUnlockUser()} style={{width:200, marginLeft:15, marginTop: 5}}></WarningButton>
                    </div>}
                </div>
                <FormStringInput label='User email address' value={email} validated={needsValidation && email === '' ? false : undefined} onChange={(val) => setEmail(val)} inputStyle={{width:280}}></FormStringInput>
                <FormCheckBox label='Receive all support emails' checked={receiveAllSupportEmails} onCheck={(val) => setReceiveAllSupportEmails(val)} style={{marginTop:15}}></FormCheckBox>
                <FormStringInput label='Support email' value={supportEmail} onChange={(val) => setSupportEmail(val)} inputStyle={{width:280}}></FormStringInput>
                <Note style={{paddingTop:6}}>If support email is left blank, user email will be used.</Note>

                <Title style={{paddingTop:30}}>User role and status</Title>
                <FormCheckBoxWithRightLabel label='Central office user' checked={isCentralOffice} onCheck={(val) => {setIsCentralOffice(val); if (!val) setCanAccessAllRecords(val)}} style={{marginTop:0}}></FormCheckBoxWithRightLabel>
                <FormCheckBoxWithRightLabel label='Can access all records' checked={canAccessAllRecords} disabled={!isCentralOffice} onCheck={(val) => setCanAccessAllRecords(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>
                <FormCheckBoxWithRightLabel label='Terms and conditions accepted' checked={true} disabled={true} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>
                <FormCheckBoxWithRightLabel label='Two Factor Authentication' checked={isTFA} onCheck={(val) => {setIsTFA(val);}} style={{marginTop:0}}></FormCheckBoxWithRightLabel>

                <Title style={{paddingTop:30}}>Password</Title>
                <div style={{display:'flex'}}>
                    <FormStringInput label='New password' value={password} validated={needsValidation && password === '' ? false : undefined} onChange={(val) => setPassword(val)} inputStyle={{width:280}} style={{paddingTop:10}}></FormStringInput>
                    {!isAddUserMode && <PrimaryButton caption='Save password' isLoading={isSavingPassword} disabled={password.length === 0} onClick={() => onSavePassword()} style={{width:110, marginLeft:15, marginTop:'auto'}}></PrimaryButton>}
                </div>
                <div style={{display:'flex', marginTop:15}}>
                    <SecondaryButton caption='Suggest password' onClick={() => onGeneratePassword()} style={{width:128, height:25}}></SecondaryButton>
                    <SecondaryButton caption='Send email' disabled={password.length === 0} isLoading={isSendingEmail} onClick={() => onSendEmail()} style={{width:128, height:25, marginLeft:25}}></SecondaryButton>
                    {!isUserReset && <SecondaryButton caption='Reset user' onClick={() => onResetUser()} style={{width:128, height:25, marginLeft:'auto'}}></SecondaryButton>}
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddUserMode ? 'Add user' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledMainUserSettings>
    )
}

export default MainUserSettings;